<template>
    <div>
        <site-navbar :activeSite="activeSociete ? activeSociete.d_nomSociete : ''"></site-navbar>
        <div class="main-navbar-wrapper">
            <nav class="main-navbar">
                <img class="navbar-logo logo" alt="Giordano Immobilier"
                    src="../../assets/images/immobilier/logo-giordano-immobilier.svg" />
                <div class="navbar-link-container" v-bind:class="{ menuOpen: menuOpen }">
                    <router-link :to="{ name: 'ImmoHome' }">Accueil</router-link>
                    <router-link :to="{ name: 'AdList' }">Acheter</router-link>
                    <router-link :to="{ name: 'Sell' }">Vendre</router-link>
                    <router-link :to="{ name: 'ImmoAgence' }">Notre Agence</router-link>
                    <router-link :to="{ name: 'ImmoContact' }">Contact</router-link>
                    <router-link :to="{ name: 'TIRecrutementForm'}" class="join-btn">
                        Nous rejoindre
                    </router-link>
                </div>
                <div class="navbar-right-container">
                    <button class="navbar-account-link cg-btn cg-btn-primary">
                        <user-icon></user-icon>
                        <p>Mon compte</p>
                    </button>
                    <router-link :to="{ name: 'TIRecrutementForm'}" class="join-btn">
                        Nous rejoindre
                    </router-link>
                    <button class="burger-btn" v-on:click="(menuOpen = !menuOpen)">
                        <img src="../../assets/icons/icn-menu.svg">
                    </button>
                </div>
            </nav>
        </div>
        <main>
            <router-view />
        </main>

        <footer>
            <div class="footer-wrapper">
                <div class="footer flex">
                    <div>
                        <img class="logo" alt="Giordano Immobilier"
                            src="../../assets/images/immobilier/logo-giordano-immobilier.svg" />
                        <p>{{ activeSociete ? activeSociete.d_mentions : '' }}</p>
                    </div>
                    <div class="contact-container">
                        <h4>Vous avez une question</h4>
                        <p>Nos équipes se tiennent à votre disposition pour toutes interrogations sur nos biens et
                            services.
                        </p>
                        <router-link :to="{ name: 'ImmoContact' }">
                            <button class="cg-btn cg-btn-primary">Contactez-nous</button>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="legal-mention-wrapper">
                <div class="legal-mention flex">
                    <p>{{ activeSociete ? activeSociete.d_nomSociete : '' }}.com - 2023 Tous droits réservés.</p>
                    <router-link :to="{ name: 'BaremeHonoraire' }">
                        Barème des honoraires
                    </router-link>
                    <router-link :to="{ name: 'ImmoMentionsLegales' }">
                        Mentions légales
                    </router-link>
                    <router-link :to="{ name: 'ImmoContact' }">
                        Nous contacter
                    </router-link>
                    <p v-html="activeSociete ? activeSociete.d_telSociete : '' "></p>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import DataApi from 'fm-data-api'
import NewsletterBar from '../Components/NewsletterBar.vue'
import SiteNavbar from '../Components/SiteNavbar.vue';
import FacebookIcon from '../Components/FacebookIcon.vue';
import LinkedinIcon from '../Components/LinkedinIcon.vue';
import UserIcon from '../Components/UserIcon.vue';

export default {
    name: 'Immobilier',
    components: {
        SiteNavbar,
        NewsletterBar,
        FacebookIcon,
        LinkedinIcon,
        UserIcon
    },
    data: () => {
        return {
            menuOpen: false,
            activeSociete: {}
        }
    },
    watch:{
        $route (to, from){
            this.menuOpen = false;
        }
    },
    async beforeMount() {
        const options = {
            apiUrl: this.$apiUrl,
            databaseName: this.$databaseName,
            token: await this.$getMainToken()
        }
        this.dataApi = new DataApi(options)
        this.dataApi.findRecords('W_Societe', { 'd_codeSociete': 'ti' }, '', '', '')
        .then((response) => {
            this.activeSociete = response[0] ? response[0]['fieldData'] : null
        })
    }
}
</script>

<style lang="scss" scoped>
::v-deep div {
    --color-primary: #ffb402;
}

::v-deep .immobilier-link {
    color: var(--color-primary) !important;
    font-weight: 600;
    cursor: default;

    &:hover {
        text-decoration: none;
    }
}
</style>
